export default {
  DEFAULT_WIDTH: '295px',
  DEFAULT_HEIGHT: '352px'
};
